import { combineReducers } from "redux-immutable";
import { routerReducer } from "react-router-redux";
import FindCE from "./components/screens/FindCE/redux/reducer";
import Login from "./components/screens/Login/redux/reducer";
import Profile from "./components/shared/redux/reducer";
import { httpReducer as http } from "./redux_util";

const appReducer = combineReducers({
  FindCE,
  Login,
  Profile,
  Router: routerReducer,
  http
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducer.js